import gsap from "gsap";
import Logon from '../authentication/Logon.vue'
import { EventBus } from '@/event-bus';
import { mapGetters } from 'vuex'

export default {
    name: "Navbar",

    components: {
        Logon
    },

    props: {},

    data: () => {
        return {};
    },

    computed: {
        ...mapGetters(
            {
                userInfo: 'user/profile',
                isAuthenticated: 'auth/isAuthenticated'
            }),
    },
    created() {
        var model = this;
        if (this.isAuthenticated) {
            this.$store.dispatch('user/userRequest')
                .catch((err) => {
                    model.$store.dispatch('auth/authLogout')
                });
        }

        EventBus.$on("logon_completed", this.logonCompleted);
    },

    methods: {
        logon: function () {
            //
            this.$router.push({ name: 'Login', query: { returnUrl: encodeURI(window.location.pathname) } });

        },

        logout() {
            var model = this;
            this.$store.dispatch('auth/authLogout')
                .then((result) => {
                    // show message
                    this.$bvToast.toast(`Ati fost deconectat.`, {
                        title: 'Logout',
                        autoHideDelay: 2000,
                    });
                    // go to home
                    model.$router.push('/');
                })
                .catch((err) => {
                    showErrorNotification(err);
                });;
        },

    },

    mounted() {
        gsap.fromTo(
            ".slogan",
            {
                x: -100,
                opacity: 0
            },
            {
                x: 0,
                opacity: 1,
                delay: 1
            }
        );

        gsap.fromTo(
            ".navbar-brand",
            {
                opacity: 0,
                scale: 0
            },
            {
                opacity: 1,
                scale: 1,
                duration: 1.5,
                ease: "slow(0.7, 0.7, false)"
            }
        );
    },

    beforeDestroy() {
        EventBus.$off("logon_completed", this.logonCompleted);
    }
};
